
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/yahoo",
      function () {
        return require("private-next-pages/destinations/yahoo.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/yahoo"])
      });
    }
  